import { lazy, Suspense } from 'react';

import type { RouteObject } from 'react-router-dom';

import PrivateRouteLayout from '../layouts/private-route-layout';
import PublicRouteLayout from '../layouts/public-route-layout';
import PrivateRouteGuard from '../route-guards/private-route-guard';
import PublicRouteGuard from '../route-guards/public-route-guard';

const SignIn = lazy(() => import('../pages/sign-in'));

const Home = lazy(() => import('../pages/home'));

const Dashboard = lazy(() => import('../pages/dashboard'));
const ListFacility = lazy(() => import('../pages/facility/list'));
const OnboardFacility = lazy(() => import('../pages/facility/onboard'));
const EditFacility = lazy(() => import('../pages/facility/edit'));
const FacilityConfiguration = lazy(
  () => import('../pages/facility/configuration')
);
const FacilityUsers = lazy(() => import('../pages/facility/users'));
const FacilityMenuPermissions = lazy(
  () => import('../pages/facility/menu-permissions')
);

const FacilitiesStats = lazy(() => import('../pages/facilities/stats'));
const BaseFacilityMenu = lazy(() => import('../pages/base-facility-menu'));
const ImpersonationLogs = lazy(() => import('../pages/impersonation-logs'));
const GlobalUsers = lazy(() => import('../pages/global-users'));

const routesConfig: RouteObject[] = [
  {
    path: '/',
    element: (
      <PrivateRouteGuard>
        <PrivateRouteLayout />
      </PrivateRouteGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <Suspense>
            <Home />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '/dashboard',
    element: (
      <PrivateRouteGuard>
        <PrivateRouteLayout />
      </PrivateRouteGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <Suspense>
            <Dashboard />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: 'facility',
    element: (
      <PrivateRouteGuard>
        <PrivateRouteLayout />
      </PrivateRouteGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <Suspense>
            <ListFacility />
          </Suspense>
        ),
      },
      {
        path: ':facilityName/onboard',
        element: (
          <Suspense>
            <OnboardFacility />
          </Suspense>
        ),
      },
      {
        path: ':facilityId/edit',
        element: (
          <Suspense>
            <EditFacility />
          </Suspense>
        ),
      },
      {
        path: ':id/configuration',
        element: (
          <Suspense>
            <FacilityConfiguration />
          </Suspense>
        ),
      },
      {
        path: ':id/users',
        element: (
          <Suspense>
            <FacilityUsers />
          </Suspense>
        ),
      },
      {
        path: ':id/menu-permissions',
        element: (
          <Suspense>
            <FacilityMenuPermissions />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: 'facilities-stats',
    element: (
      <PrivateRouteGuard>
        <PrivateRouteLayout />
      </PrivateRouteGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <Suspense>
            <FacilitiesStats />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: 'base-facility-menu',
    element: (
      <PrivateRouteGuard>
        <PrivateRouteLayout />
      </PrivateRouteGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <Suspense>
            <BaseFacilityMenu />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: 'impersonation-logs',
    element: (
      <PrivateRouteGuard>
        <PrivateRouteLayout />
      </PrivateRouteGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <Suspense>
            <ImpersonationLogs />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: 'global-users',
    element: (
      <PrivateRouteGuard>
        <PrivateRouteLayout />
      </PrivateRouteGuard>
    ),
    children: [
      {
        path: '',
        element: (
          <Suspense>
            <GlobalUsers />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: 'auth',
    element: <PublicRouteLayout />,
    children: [
      {
        path: 'sign-in',
        element: (
          <PublicRouteGuard>
            <Suspense>
              <SignIn />
            </Suspense>
          </PublicRouteGuard>
        ),
      },
    ],
  },
];

export default routesConfig;
